import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface SectionFAQProps {
  title: string;
  items: FAQItem[];
}

const SectionFAQ: React.FC<SectionFAQProps> = ({ title, items }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="lp-section lp-section--objections" aria-labelledby="faq-title">
      <div className="lp-container">
        <h2 id="faq-title">{title}</h2>
        <div className="lp-faq" role="list">
          {items.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <article key={i} className={`lp-faq__item ${isOpen ? 'lp-faq__item--open' : ''}`} role="listitem">
                <button
                  className="lp-faq__trigger"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${i}`}
                >
                  <h3>
                    <i className="fa-solid fa-circle-question" aria-hidden="true" /> {item.question}
                  </h3>
                  <i className={`fa-solid fa-chevron-down lp-faq__chevron ${isOpen ? 'lp-faq__chevron--open' : ''}`} aria-hidden="true" />
                </button>
                <div
                  id={`faq-answer-${i}`}
                  className="lp-faq__answer"
                  role="region"
                  aria-labelledby={`faq-question-${i}`}
                  hidden={!isOpen}
                >
                  <p>{item.answer}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectionFAQ;
